import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import HelloWorld from './components/HelloWorld.vue';
const Ducking = () => import('./components/JeepDucking.vue');
const ProductSpotlight = () => import('./components/ProductSpotlight.vue');
const JeepEvents = () => import('./components/JeepEvents.vue');
const JeepClubs = () => import('./components/JeepClubs.vue');
const AboutUs = () => import('./components/AboutUs.vue');
const AdminDashboard = () => import('./components/AdminDashboard.vue');

const AddEvent = () => import('./components/AddEvent.vue');
const UploadDebug = () => import('./components/UploadDebug.vue');

const routes = [
	{
		path: '/add-event',
		name: 'AddEvent',
		component: AddEvent,
		meta: {
			title: 'Add New Event - JeepWarehouse.com',
			description: 'Add your Jeep event to our community calendar at JeepWarehouse.com'
		}
	},
	{
		path: '/upload-debug',
		name: 'UploadDebug',
		component: UploadDebug,
		meta: {
			title: 'Upload Debug - JeepWarehouse.com',
			description: 'Debug upload functionality at JeepWarehouse.com'
		}
	},
	{
		path: '/admin-dashboard-jw2025',
		name: 'AdminDashboard',
		component: AdminDashboard,
		meta: {
			title: 'Admin Dashboard - JeepWarehouse.com',
			description: 'Manage JeepWarehouse.com content and community features'
		}
	},
	{
		path: '/ducking',
		name: 'Ducking',
		component: Ducking,
		meta: {
			title: 'Jeep Showcase - JeepWarehouse.com',
			description: 'Share photos of your Jeep and connect with the Jeep community at JeepWarehouse.com'
		}
	},
	{
		path: '/',
		name: 'Home',
		component: HelloWorld,
		meta: {
			title: 'JeepWarehouse.com - Where the Jeep Wave Never Ends',
			description: 'Join the Jeep community at JeepWarehouse.com—share your Jeep photos, find upcoming events, connect with Jeep clubs across the country, and explore YouTube Jeep adventures. Built by Jeepers, for Jeepers.'
		}
	},
	{
		path: '/spotlight',
		name: 'ProductSpotlight',
		component: ProductSpotlight,
		meta: {
			title: 'Product Spotlight - JeepWarehouse.com',
			description: 'Discover the best Jeep products and accessories at JeepWarehouse.com'
		}
	},
	{
		path: '/events',
		name: 'JeepEvents',
		component: JeepEvents,
		meta: {
			title: 'Jeep Events Calendar - JeepWarehouse.com',
			description: 'Find upcoming Jeep events and meetups near you at JeepWarehouse.com'
		}
	},
	{
		path: '/clubs',
		name: 'JeepClubs',
		component: JeepClubs,
		meta: {
			title: 'Jeep Clubs Directory - JeepWarehouse.com',
			description: 'Connect with Jeep clubs across the country at JeepWarehouse.com'
		}
	},
	{
		path: '/about',
		name: 'AboutUs',
		component: AboutUs,
		meta: {
			title: 'About JeepWarehouse.com - Jeep TV Management',
			description: 'Learn about JeepWarehouse.com and manage YouTube Jeep channels'
		}
	},
	{
		path: '/tv',
		name: 'JeepTV',
		component: () => import('./components/jwTubeGuide.vue'),
		meta: {
			title: 'Jeep TV - YouTube Channels - JeepWarehouse.com',
			description: 'Explore YouTube Jeep channels packed with tips, stories, and adventures at JeepWarehouse.com'
		}
	}
];

const router = createRouter({
	// Use hash mode for production compatibility if needed
	history: process.env.NODE_ENV === 'production' ? createWebHashHistory() : createWebHistory(),
	routes
});

// Update page title and meta description on route change
router.afterEach((to) => {
	// Update page title
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	
	// Update meta description
	if (to.meta.description) {
		let metaDescription = document.querySelector('meta[name="description"]');
		if (metaDescription) {
			metaDescription.setAttribute('content', to.meta.description);
		} else {
			metaDescription = document.createElement('meta');
			metaDescription.name = 'description';
			metaDescription.content = to.meta.description;
			document.getElementsByTagName('head')[0].appendChild(metaDescription);
		}
	}
});

export default router;
